<template>
  <el-container>
    <div class="header-box">
      <div class="b-header-left">
        <span class="b-width">
          <el-input
            :size="eleSize"
            placeholder="输入内容搜索"
            v-model="keyWord"
          >
          </el-input>
        </span>
        <!-- 选择器 -->
        <el-select
          :size="eleSize"
          v-model="drivewayId"
          style="margin:0 20px;"
          placeholder="选择绑定通道"
        >
          <el-option
            v-for="item in drivewayList"
            :key="item.drivewayId"
            :label="item.drivewayName"
            :value="item.drivewayId"
          >
          </el-option>
        </el-select>
        <!-- 查询按钮 -->
        <el-button type="primary" @click="clearClick()"> 清空条件</el-button>
        <el-button type="primary" @click="queryUserName()"> 查询用户</el-button>
        <el-button
          :size="eleSize"
          type="primary"
          class="b-add-user"
          @click="BMDaddUser()"
          >添加用户
        </el-button>
      </div>
      <div>
        <el-button
          :size="eleSize"
          type="success"
          class="b-bangding-user"
          @click="bangdingDialogClick"
        >
          人员绑定通道</el-button
        >
        <el-button type="primary" @click="SynchronizeData"
          >同步白名单</el-button
        >
      </div>
      <!-- 绑定人员弹框 -->
      <el-dialog
        title="人员数据绑定"
        :visible.sync="bangdingDialog"
        width="60%"
      >
        <div class="transfer-box">
          <!-- 穿梭框 -->
          <el-transfer
            :data="drivewayList"
            v-model="changeDrivewayList"
            :titles="['通道', '已选择']"
            :props="{
              key: 'drivewayId',
              label: 'drivewayName'
            }"
          >
          </el-transfer>
          <hr />
          <el-transfer
            :data="bangdingAllUserList"
            v-model="changeUserList"
            :titles="['人员', '已选择']"
            :props="{
              key: 'userId',
              label: 'name'
            }"
          >
            <el-button
              class="transfer-footer"
              slot="left-footer"
              size="small"
              @click="userMoreLoad"
              type="primary"
              >{{
                pagination.total > bangdingAllUserList.length
                  ? "更多数据"
                  : "无数据了"
              }}</el-button
            >
            <el-button
              @click="changeUserList = []"
              class="transfer-footer"
              slot="right-footer"
              size="small"
              type="primary"
            >
              清空
            </el-button>
          </el-transfer>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="bangdingDialog = false">取 消</el-button>
          <el-button type="primary" @click="bangdingUserAndDriveway"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 表格 -->
    <el-main class="main-content">
      <!-- 全部成员表格 -->
      <el-table
        row-key="userId"
        v-if="showDrivewayStatus"
        stripe
        border
        :header-cell-style="{ background: '#f4f4f4', color: '#409eff' }"
        :data="allUserList"
        size="mini"
      >
        <!-- 小屏幕展示 -->
        <el-table-column align="center" type="expand" v-if="showDrivewayStatus">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="查看可通行通道：">
                <el-link
                  type="success"
                  @click="lookAgreenPass(props.row.userId, props.row)"
                >
                  查看
                </el-link>
              </el-form-item>
              <br />
              <el-form-item label="可通行通道：">
                <el-tag
                  v-for="drivewayId in props.row.okpass"
                  :key="drivewayId"
                  closable
                  type="success"
                  @close="removeDrived(drivewayId, props.row)"
                >
                  {{ drivewayId | getDrivewayName(that) }}
                </el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="phoneNum"
          label="手机号"
        ></el-table-column>
        <el-table-column align="center" prop="sex" label="性别">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == 1">男</span>
            <span v-if="scope.row.sex == 2">女</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="icNum"
          label="IC卡号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="types"
          label="人员类型"
          :filters="[
            { text: '普通用户', value: '1' },
            { text: '户主用户', value: '2' },
            { text: '外来人员', value: '3' }
          ]"
          :filter-method="filterTag"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.types == 1">普通用户</span>
            <span v-if="scope.row.types == 2">户主用户</span>
            <span v-if="scope.row.types == 3">外来人员</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="remarks"
          label="备注"
        ></el-table-column>
        <el-table-column
          width="260"
          align="center"
          label="操作"
          v-if="!eleSize"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="changeUserInfo(scope.row)"
              >修改用户</el-button
            >
            <el-button @click="removeUser(scope.row)" type="danger" size="mini">
              删除</el-button
            >
            <el-button
              @click="ruleBtn(scope.row, 'all')"
              :type="scope.row.icCardStatus == 1 ? 'success' : 'info'"
              size="mini"
            >
              {{ scope.row.icCardStatus == 1 ? "启用" : "禁用" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 通道查询表格 -->
      <div v-if="showDrivewayStatus1" class="show-driveway-user">
        <div class="has-user">
          <h1>此通道已有成员</h1>
          <el-table
            stripe
            border
            :header-cell-style="{ background: '#409eff', color: '#fff' }"
            :data="drivewayDataList"
            size="mini"
          >
            <el-table-column
              align="center"
              prop="dusername"
              label="姓名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="duserIcNum"
              label="IC卡号"
            ></el-table-column>
            <el-table-column align="center" width="200" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="ruleBtn(scope.row, 'driveway0')"
                  type="danger"
                  >解绑此通道</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <p>
            <el-pagination
              @size-change="handleSizeChangeH"
              @current-change="handleCurrentChangeH"
              :current-page="paginationH.page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="paginationH.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paginationH.total"
            >
            </el-pagination>
          </p>
        </div>
        <div class="no-user">
          <h1>不在此通的成员</h1>
          <el-table
            stripe
            border
            :header-cell-style="{ background: '#409eff', color: '#fff' }"
            :data="noDrivewayDataList"
            size="mini"
          >
            <el-table-column
              align="center"
              prop="name"
              label="姓名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="icNum"
              label="IC卡号"
            ></el-table-column>
            <el-table-column align="center" width="200" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="ruleBtn(scope.row, 'driveway1')"
                  type="success"
                  >绑定到此通道</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <p>
            <el-pagination
              @size-change="handleSizeChangeN"
              @current-change="handleCurrentChangeN"
              :current-page="paginationN.page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="paginationN.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paginationN.total"
            >
            </el-pagination>
          </p>
        </div>
      </div>
      <!-- tankuang -->
      <el-dialog title="添加用户" :visible.sync="addUserDialog">
        <el-form class="dialog-form">
          <el-form-item label="用户姓名：" :label-width="formLabelWidth">
            <el-input class="int-w" v-model="addUserForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码：" :label-width="formLabelWidth">
            <el-input
              class="int-w"
              maxlength="11"
              v-model="addUserForm.phoneNum"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户性别：" :label-width="formLabelWidth">
            <el-radio-group v-model="addUserForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="用户类型：" :label-width="formLabelWidth">
            <el-radio-group v-model="addUserForm.types">
              <el-radio :label="1">普通用户</el-radio>
              <!-- <el-radio :label="2">户主用户</el-radio> -->
              <el-radio :label="3">外来人员</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="用户IC卡号：" :label-width="formLabelWidth">
            <el-input class="int-w" v-model="addUserForm.icNum"></el-input>
          </el-form-item>
          <el-form-item label="备注信息：" :label-width="formLabelWidth">
            <el-input
              class="int-w"
              type="textarea"
              v-model="addUserForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addUserDialog = false">取 消</el-button>
          <el-button type="primary" @click="addUserDialogSure()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </el-main>
    <el-footer v-if="!showDrivewayStatus1">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      that: this,
      keyWord: "", //查询用户的姓名关键字
      eleSize: "", //
      changeDrivewayList: [], //选择的通道列表--多选操作
      drivewayId: "", //选择的通道ID
      drivewayList: [], //通道列表
      showDrivewayStatus: true, //是否展示同代表
      showDrivewayStatus1: false, //是否展示同代表
      changeUserList: [], //表格选择的数据
      allUserList: [], //查询到的所有数据
      addUserForm: {
        loginId: "",
        name: "",
        sex: 1,
        types: 1, //1普通2户主3外部人员
        icNum: "",
        relation: "7", //关系
        phoneNum: "",
        remarks: "" //备注。。。。。
      },
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      paginationH: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      paginationN: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      drivewayDataList: [], //通道数据列表
      noDrivewayDataList: [], //没有绑定该通道的对应数据
      addUserDialog: false, //添加弹框
      formLabelWidth: "150px",
      bangdingDialog: false, //绑定数据弹框
      bangdingAllUserList: [] //绑定数据弹框
    };
  },
  filters: {
    getDrivewayName(data, that) {
      console.log(data);
      if (!data) return "--暂无数据--";
      let drivewayName = that.drivewayList.find(k => k.drivewayId == data)
        .drivewayName;
      return drivewayName;
    },
    setTimeData(time, that) {
      return that.moment(time).format("LLL");
    }
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.queryDrivewayList();
    this.getAllUser();
  },
  mounted() {},
  methods: {
    /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getAllUser();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAllUser();
    },
    handleSizeChangeH(val) {
      this.paginationH.pageSize = val;
      this.queryDrivewayDataList();
    },
    handleCurrentChangeH(val) {
      this.paginationH.currentPage = val;
      this.queryDrivewayDataList();
    },
    handleSizeChangeN(val) {
      this.paginationN.pageSize = val;
      this.queryDrivewayDataList();
    },
    handleCurrentChangeN(val) {
      this.paginationN.currentPage = val;
      this.queryDrivewayDataList();
    },
    /*
     **  @description 更多用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    userMoreLoad() {
      this.pagination.currentPage++;
      this.getAllUser();
    },
    /**
     * @description 移除
     * @param {}
     * @return
     * @author shipingan
     **/
    removeDrived(drivewayId, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            drivewayId,
            dUserId: row.userId
          };
          this.$axios
            .post("/dapi/nhw/deleteDrivewayUser", this.$qs.stringify(params))
            .then(res => {
              let data = res.data;
              if (data.status == 200) {
                this.lookAgreenPass(row.userId, row);
              } else {
                this.$message.error(data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /*
     **  @description 查询通道列表
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryDrivewayList() {
      this.$axios
        .get(`/dapi/nhw/driveway/find?drivewayArea=${this.userinfo.uid}`)
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            if (data.data.length > 0) {
              this.drivewayList = data.data;
            }
          } else {
            this.$message.error("暂无通道数据");
          }
        });
    },
    //筛选
    filterTag(value, row) {
      return row.types == value;
    },
    /*
     **  @description 查询ALL用户数据List
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getAllUser() {
      Object.assign(this.$data.addUserForm, this.$options.data().addUserForm);
      this.$axios
        .get("/dapi/nser/queryAllNetUser", {
          params: {
            loginId: this.userinfo.uid,
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
            keyWord: this.keyWord
          }
        })
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            this.pagination.total = data.rowCount;
            this.allUserList = data.data;

            if (this.bangdingDialog) {
              this.bangdingAllUserList = [
                ...this.bangdingAllUserList,
                ...data.data
              ];
            } else {
              this.bangdingAllUserList = data.data;
            }
            this.noDrivewayDataList = data.data;
          }
        });
    },
    /*
     **  @description 添加白名单
     **  @param {}
     **  @return
     **  @author shipingan
     */
    BMDaddUser() {
      this.$data.addUserForm = this.$options.data().addUserForm;
      this.addUserDialog = true;
    },
    addUserDialogSure() {
      this.addUserForm.loginId = this.userinfo.uid;
      let url = "";
      if (this.addUserForm.name == "") {
        this.$message.error("姓名不能为空！");
        return;
      }
      // if (this.addUserForm.icNum == "") {
      //   this.$message.error("IC卡不能为空！");
      //   return;
      // }
      // 如果存在userId  则修改
      if (this.addUserForm.userId != undefined) {
        url = "/dapi/nser/updateUser";
      } else {
        url = "/dapi/nser/saveUser";
      }
      this.$axios
        .post(
          url,
          this.$qs.stringify({
            ...this.addUserForm
          })
        )
        .then(data => {
          let res = data.data;
          if (res.status == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.getAllUser();
            this.addUserDialog = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    /*
     **  @description 绑定人员通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    bangdingDialogClick() {
      this.bangdingDialog = true;
    },
    bangdingUserAndDriveway() {
      if (this.changeUserList.length == 0) {
        this.$message.error("请选需要绑定的人员");
        return;
      }
      if (this.changeDrivewayList.length == 0) {
        this.$message.error("请选需要绑定的通道");
        return;
      }
      let userList = [];
      this.changeUserList.map(item => {
        let obj = this.bangdingAllUserList.find(k => k.userId == item);
        userList.push(obj);
      });
      let params = {
        drivewayList: JSON.stringify(this.changeDrivewayList),
        userList: JSON.stringify(userList)
      };
      this.$axios
        .post("/dapi/nhw/driveway/user/add", this.$qs.stringify(params))
        .then(data => {
          let res = data.data;
          if (res.status == 200) {
            this.$message({
              type: "success",
              message: "绑定成功/请同步数据"
            });
            Object.assign(
              this.$data.pagination,
              this.$options.data().pagination
            );
            this.changeUserList = this.changeDrivewayList = [];
            this.getAllUser();
            this.bangdingDialog = false;
          } else if (res.status == 503) {
            Object.assign(
              this.$data.pagination,
              this.$options.data().pagination
            );
            this.$message.error(res.message);
            this.changeUserList = this.changeDrivewayList = [];
            this.getAllUser();
            this.bangdingDialog = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    /*
                     **  @description 获取通道下的数据
                     **  @param {} userId 人员ID
                      isNotBindPage 未绑定页码
                      isNotBindSize 未绑定每页个数
                      isBindPage  已绑定页码
                      isBindSize  已绑定每页个数
                      netArea 小区id
                     **  @return
                     **  @author shipingan
                     */
    async queryDrivewayDataList() {
      let params = {
        drivewayId: this.drivewayId,
        isBindPage: this.paginationH.currentPage,
        isBindSize: this.paginationH.pageSize,
        isNotBindPage: this.paginationN.currentPage,
        isNotBindSize: this.paginationN.pageSize,
        netArea: this.userinfo.uid
      };
      await this.$axios
        .get("/dapi/nhw/driveway/user/find", {
          params: {
            ...params
          }
        })
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            //查询到对应通道的数据
            this.drivewayDataList = data.data.isBindUsers;
            this.noDrivewayDataList = data.data.isNotBindUsers;
            this.paginationH.total = data.data.isBindUsersSize;
            this.paginationN.total = data.data.isNotBindUsersSize;
            // 展示
            this.showDrivewayStatus = false;
            setTimeout(() => {
              this.showDrivewayStatus1 = true;
            }, 10);
          } else {
            this.drivewayDataList = [];
            this.showDrivewayStatus = false;
            this.showDrivewayStatus1 = true;
          }
        });
    },
    /*
     **  @description 通过userID查询用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    async getUserDrivewayByUserIduserId(userId) {
      return await this.$axios.get("/dapi/nhw/driveway/user/findByUser", {
        params: { userId: userId }
      });
      // .then(res => {
      //   let data = res.data;
      //   if (data.status == 200) {
      //     this.drivewayDataList = data.data;
      //   } else {
      //     this.drivewayDataList = [];
      //   }
      // });
    },
    lookAgreenPass(userId, item) {
      this.getUserDrivewayByUserIduserId(userId).then(res => {
        if (!res.data.data || !res.data.data.length)
          this.$message.warning("暂无数据");
        this.$set(item, "okpass", res.data.data);
      });
    },
    /*
     **  @description 查询用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryUserName() {
      if (this.drivewayId != "") {
        this.queryDrivewayDataList();
        return;
      }
      this.getAllUser();
      this.showDrivewayStatus1 = false;
      setTimeout(() => {
        this.showDrivewayStatus = true;
      }, 100);
    },
    /*
     **  @description 同步白名单
     **  @param {}
     **  @return
     **  @author shipingan
     */
    SynchronizeData() {
      let firstNotify = this.$notify({
        title: "数据同步",
        dangerouslyUseHTMLString: true,
        message: `<p>同步中。。。</p>`
      });
      this.$axios
        .post(
          "/dapi/nhw/handSelf/whitelist",
          this.$qs.stringify({
            areaId: this.userinfo.uid
          })
        )
        .then(res => {
          // 关闭同步中
          firstNotify.close();
          let data = res.data;
          if (data.status == 200) {
            this.$notify({
              title: "数据同步",
              dangerouslyUseHTMLString: true,
              message: `<p>同步完成</p>`,
              type: "success"
            });
          } else {
            this.$notify({
              title: "数据同步",
              dangerouslyUseHTMLString: true,
              message: `<p>同步失败:${data.message}</p>`,
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.$message.error("服务器异常");
        });
    },

    /*
     **  @description 修改用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changeUserInfo(row) {
      this.addUserForm = {
        ...row
      };
      this.addUserDialog = true;
    },
    /*
     **  @description 删除用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeUser(row) {
      this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(
              "/dapi/nser/deleteUser",
              this.$qs.stringify({
                userId: row.userId
              })
            )
            .then(data => {
              let res = data.data;
              if (res.status == 200) {
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.getAllUser();
              } else {
                this.$message.error(res.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /*
                    **  @description 启用禁用
                    **  @param {}
                    **  @return
                    // /dapi/nhw/disabled/user
                        post
                        参数：drivewayId 通道id
                          dUserId  用户id
                          delFlag 标记（停用传0，启用传1
                    **  @author shipingan
                    */
    ruleBtn(row, who) {
      let params;
      let url = "";
      if (who == "all") {
        url = "/dapi/nhw/disabled/user";
        params = {
          dUserId: row.userId,
          delFlag: row.icCardStatus
        };
      } else if (who == "driveway0") {
        url = "/dapi/nhw/deleteDrivewayUsersByUId";
        params = {
          userId: row.duserId,
          drivewayId: this.drivewayId
        };
      } else {
        url = "/dapi/nhw/driveway/user/add";
        params = {
          drivewayList: JSON.stringify([this.drivewayId]),
          userList: JSON.stringify([row])
        };
      }
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(res => {
          let data = res.data;
          if (data.status == 200 || data == 1) {
            this.$message({
              type: "success",
              message: params.delFlag == 0 ? "停用成功" : "启用成功"
            });
            if (who == "all") {
              this.getAllUser();
            } else {
              this.queryDrivewayDataList();
            }
          } else {
            this.$message.error(data.message);
            if (who == "all") {
              this.getAllUser();
            } else {
              this.queryDrivewayDataList();
            }
          }
        })
        .catch(err => {
          this.$message.error("服务器异常");
        });
    },
    /*
     **  @description 数据清空
     **  @param {}
     **  @return
     **  @author shipingan
     */
    clearClick() {
      this.keyWord = "";
      this.drivewayId = "";
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.header-box {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  box-shadow: @box-shadow;
  .b-header-left {
    display: flex;
    .b-add-user {
      //   margin-left: 20px;
    }
  }
  .b-bangding-user {
  }
}
.dialog-form .int-w {
  width: 217px;
}
.show-driveway-user {
  display: flex;
  justify-content: space-around;
  .has-user {
    flex: 1;
    box-shadow: @box-shadow;
    padding: 10px;
    margin: 10px;
    position: relative;
    h1 {
      margin: 10px;
    }
    .el-table {
      margin-bottom: 60px;
    }
    p {
      margin-top: 10px;
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
  }
  .no-user {
    .has-user;
  }
}
/deep/ .el-dialog {
  margin-top: 15px !important;
  .transfer-box {
    .el-transfer-panel__header {
      height: auto;
      padding: 5px;
    }
    .el-checkbox {
      display: flex !important;
    }
    .el-checkbox__label {
      text-align: left !important;
    }
  }
}
</style>
